export const BEZEQ_CAMERA = {};
